<script setup lang="ts">
import { computed } from 'vue'
import type { Product } from "~/models/Product"

/**
 *
 *  Props and emits section
 *
 *
*/

const props = defineProps<{
    product: Product
}>()

/**
 *
 *  Ref, computed and hooks section
 *
 *
*/

const computedProduct = computed(() => props.product)

const canShippingMethodEnabled = computed(() => {
    if(computedProduct.value?.store_shipping_method?.length === 0) return undefined
    
    if(computedProduct.value?.store_shipping_method?.some(item => item.value === 'home_shipping') && computedProduct.value?.store_shipping_method?.some(item => item.value === 'local_pickup')){
        return 'both'
    }else if(computedProduct.value?.store_shipping_method?.every(item => item.value === 'home_shipping')){
        return 'home_shipping'
    }else if(computedProduct.value?.store_shipping_method?.every(item => item.value === 'local_pickup')){
        return 'local_pickup'
    }

    return undefined
})

/**
 *
 *  Life cicle events
 *
 *
*/

/**
 *
 *  Functions section
 *
 *
*/
</script>

<template>
    <div class="tw-hidden md:tw-flex tw-gap-2 tw-items-center">
        <q-tooltip v-if="canShippingMethodEnabled === 'both'">Envío disponible y recogida en el local</q-tooltip>
        <template v-if="canShippingMethodEnabled === 'home_shipping' || canShippingMethodEnabled === 'both'">
            <div>
                <q-icon name="local_shipping" size="1rem" color="primary" />
                <q-tooltip v-if="canShippingMethodEnabled !== 'both'">Envío disponible</q-tooltip>
            </div>
        </template>
        <template v-if="canShippingMethodEnabled === 'local_pickup' || canShippingMethodEnabled === 'both'">
            <div>
                <q-icon name="storefront" size="1rem" color="primary" />
                <q-tooltip v-if="canShippingMethodEnabled !== 'both'">Solo recogida en el local</q-tooltip>
            </div>
        </template>
    </div>
</template>